import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import { Button } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column'
  },
  textfield: {
    margin: '0px',
    color: theme.palette.text.secondary,
    width: '256px',
    '& > label': {
      color: '#999'
    }
  },
  subText: {
    fontSize: '12px',
    marginTop: '0px'
  },
  button: {
    width: '128px',
    padding: '12px',
    margin: '8px 0px'
  }
}));

export default ({ locale, onSubmit }) => {
  const classes = useStyles();

  const [temperature, setTemperature] = useState('');

  return (
    <ValidatorForm
      className={classes.form}
      onSubmit={() => onSubmit(temperature || 'not provided')}
    >
      <TextValidator
        id="temperature"
        name="temperature"
        type="number"
        className={classes.textfield}
        label={`${locale.input_labels.temp} (\xB0F)`}
        value={temperature}
        onChange={e => setTemperature(e.target.value)}
        variant="outlined"
        inputProps={{
          step: '0.1',
          min: '90',
          max: '110',
          'data-testid': 'temperature-input'
        }}
      />
      <p className={classes.subText}>{locale.questionnaire.temp_sub_text}</p>
      <Button
        id="btn-submit-temperature"
        className={classes.button}
        type="submit"
        color="primary"
        variant="contained"
      >
        {locale.button_labels.submit}
      </Button>
    </ValidatorForm>
  );
};
